module.exports = __webpack_public_path__ + "3b1aa444a8b6c0efbcbea9b37bb39a73.svg";